






























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { msgTypeEnum } from '@/store/types';
import TIM from 'tim-js-sdk'
import { whichAnimationEndEvent } from '@/utils'
import TimInstance from 'utils/imbase/index';
import { saveLiveRoomUpShare } from '@/api/Anchor'
import GiftList from './GiftList.vue'
import { addUpHeaters, postMessage, redirectUrlPrefix, redirectTo } from '../utils'

@Component({
  components: {
    GiftList
  },
})
export default class TalkArea extends Vue {
  @Prop() private roomId!: string;
  @Prop() private showTalkBtn!: boolean;
  @Prop() private showGiftListBtn!: boolean;
  @Prop() private showUpBtn!: boolean;
  private showGiftList = false

  private msg = ''
  private inputFocus = false
  private get liveRoomMsg () {
    return this.$store.state.liveRoomMsg
  }

  private onMsgInputBlur() {
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 100)
  }

  private get userInfo () {
    return this.$store.state.userInfo
  }

  private get upHeaters () {
    return this.$store.state.upHeaters
  }


  @Watch('upHeaters', {immediate: true, deep: true})
  private onChangeUpHeaters (newVal, oldVal) {
    const animationEndEvent = whichAnimationEndEvent()
    const id = (newVal[newVal.length - 1] || {}).id
    if (id) {
      this.$nextTick(function () {
        // DOM 现在更新了
        // `this` 绑定到当前实例
        // @ts-ignore
        this.$refs[id][0].addEventListener(animationEndEvent, this.listenAnimationEnd.bind(this, id))
      })
    }
  }

  private listenAnimationEnd (id) {
    const animationEndEvent = whichAnimationEndEvent()
    const upHeaters = this.upHeaters.slice()
    upHeaters.some(((item, index) => {
      const flag = item.id === id
      if (flag) {
        upHeaters.splice(index, 1)
      }
      return flag
    }))
    // @ts-ignore
    this.$refs[id][0].removeEventListener(animationEndEvent, this.listenAnimationEnd)
    setTimeout(() => {
      this.$store.dispatch('updateUpHeaters', upHeaters)
    }, 0)
  }

  private showGiftListBtnClicked () {
    postMessage({
      userAction: 0,
      actionParam: 1
    })
    this.showGiftList = !this.showGiftList
  }

  private withLogin (func) {
    if (this.userInfo.isTourist) {
      this.$weui.dialog({
        title: '提示',
        content: '请先登录',
        buttons: [{
            label: '确定',
            type: 'primary',
            onClick: () => {console.log('确定')}
        }]
      })
      return
    }
    func()
  }

  private saveLiveRoomUpShare () {
    addUpHeaters(this)
    postMessage({
      userAction: 0,
      actionParam: 2
    })
    saveLiveRoomUpShare(this.roomId, this.$store.state.sid)
  }

  @Watch('msg', {immediate: true, deep: true})
  private onMsgInputChange(newVal, oldVal) {
    console.log(newVal.length)
    if (newVal.length > 60) {
      this.msg = oldVal
    }
  }

  private onInputFocus() {
    this.inputFocus = true
  }

  private onInputBlur() {
    this.inputFocus = false
  }

  private sendMsg() {
    if (!this.msg) {
      this.$weui.dialog({
        title: '提示',
        content: '请先输入消息',
        buttons: [{
            label: '确定',
            type: 'primary',
            onClick: () => {console.log('确定')}
        }]
      })
      return
    }
     // 发送成功
    this.$store.dispatch('updateLiveRoomMsg', {
      name: this.userInfo.userName,
      message:  this.msg,
      msgType: msgTypeEnum.COMMON_MSG
    })
    const message = TimInstance.tim.createCustomMessage({
      to: this.roomId,
      conversationType: TIM.TYPES.CONV_GROUP,
      payload: {
        data: JSON.stringify({
          userAction: 7,
          actionParam: 7,
          NickName: this.userInfo.userName,
          Content: this.msg,
          HeadUrl: this.userInfo.userImg,
          Company: this.userInfo.allFullPathCn,
          RoomId: this.roomId,
          MuteUserId: ''
        })
      }
    });
    this.onInputBlur()
    this.msg = ''
    let promise = TimInstance.tim.sendMessage(message);
    promise.then((imResponse) => {
      this.msg = ''
      postMessage({
        userAction: 0,
        actionParam: 3
      })
      console.log('sendMessage success', imResponse);
    }).catch((imError) => {
      // 发送失败
      console.warn('sendMessage error:', imError);
    });
  }
}
